import { A9Service } from 'components/system/angular';
import { AbstractDataProviderV2, IDataProviderV2 } from 'components/system';
import { RsCustomerStatDash } from './types/RsCustomerStatDash';

export type ICustomerDashboardStatisticsDataProvider = IDataProviderV2<{}, RsCustomerStatDash>;

@A9Service('customerDashboardStatisticsDataProvider')
export class CustomerDashboardStatisticsDataProvider extends AbstractDataProviderV2<{}, RsCustomerStatDash> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/{customerId}/stat/dash');
    }

    public add(): Promise<any> {
        return Promise.reject('method is not supported');
    }

    public list(): Promise<any> {
        return Promise.reject('method is not supported');
    }

    public update(): Promise<any> {
        return Promise.reject('method is not supported');
    }

    public patch(): Promise<any> {
        return Promise.reject('method is not supported');
    }

    public delete(): Promise<any> {
        return Promise.reject('method is not supported');
    }
}
